window.addEventListener("postscriptPopup", function(ev) {
  console.log(ev);
    if (ev.detail.type === 'formSubmit') {
        handlePopupSubmit(ev.detail)  // your function
    }
});


// This is a function for expanding description blocks
for (let expandEl of document.getElementsByClassName("expand-section")) {
  expandEl.addEventListener("click", function () {
    var idElementToExpand = expandEl.getAttribute("section-to-expand");
    var containerElement = document.getElementById(idElementToExpand);
    var containerScrollState = containerElement.getAttribute("aria-expanded");
    var elementHeight = containerElement.scrollHeight;
    var readMoreFade = document.querySelector(
      `#${idElementToExpand} .read-more-fade`
    );
    var readMoreButton = document.querySelector(
      `#${idElementToExpand} + .read-more-button`
    );

    if (
      containerScrollState === "false" ||
      idElementToExpand == "fibc-info-dropdown"
    ) {
      containerElement.style.maxHeight = elementHeight + "px";
      if (readMoreFade) {
        readMoreFade.style.display = "none";
        readMoreButton.innerHTML = "Read less";
      }
      containerElement.setAttribute("aria-expanded", "true");
    } else {
      containerElement.style.maxHeight = "250px";
      if (readMoreFade) {
        readMoreFade.style.display = "block";
        readMoreButton.innerHTML = "Read more";
      }
      containerElement.setAttribute("aria-expanded", "false");
    }
  });
}

// PRODUCT MEDIA IMAGE SCROLL
let clickTracker = 0;
function productMediaSelect(mediaIndex, elContainer) {
  clickTracker = mediaIndex;
  const currentScrollPosition = $(`#${elContainer}`).width();
  $(`#${elContainer}`).scrollLeft(currentScrollPosition * mediaIndex);
}

// SCROLL FUNCTION
function elementScroll(direction, containerId) {
  const elWidth = $(`#${containerId}`).width();
  const containerEl = document.getElementById(containerId);
  if (direction == "forward") {
    if (clickTracker + 1 < (containerEl.childNodes.length - 1) / 2) {
      clickTracker++;
      containerEl.scrollLeft = elWidth * clickTracker;
    }
  } else {
    if (clickTracker - 1 >= 0) {
      clickTracker--;
      containerEl.scrollLeft = elWidth * clickTracker;
    }
  }
}

var onPageUpsellVid;
var onPageUpsellLineProperty;
var radioBtn;
function upsellCardClicked(vid, prop) {
  onPageUpsellVid = vid;
  onPageUpsellLineProperty = prop;
  radioBtn = $("#upsell-card-check");

  if (radioBtn.attr("isChecked") == "yes") {
    $("#upsell-card-check svg").css("display", "none");
    radioBtn.attr("isChecked", "no");
  } else {
    $("#upsell-card-check svg").css("display", "block");
    radioBtn.attr("isChecked", "yes");
  }
}

function subMenuOpen() {
  document
    .getElementsByClassName(".list-menu__item")
    .setAttribute("class", "subMenuTextColor");
}

function navDropDownOpen(navIndex) {
  document.getElementById("Details-HeaderMenu-" + navIndex).open = "open";
}
function navDropDownClose(navIndex) {
  document.getElementById("Details-HeaderMenu-" + navIndex).open = "";
}


// Skio Customer Portal - Customizations Script
const variantTitle = "Next Month's Book";
document.addEventListener("DOMContentLoaded", function() {
  if (window.location.href.includes("/a/account/")) {
    let lastUrl = window.location.href; 
    skioOnUrlChange(lastUrl);
    new MutationObserver(() => {
      let url = window.location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        skioOnUrlChange(lastUrl, url);
      }
    }).observe(document, {subtree: true, childList: true});
  }
});

function skioOnUrlChange(lastUrl, url = '') {
  if (url == '') url = lastUrl;
  if (!url.includes("/a/account/login")) {
    skioWaitForElm('#__next .SubscriptionGroup-Active h3').then(() => {
      setTimeout( function() {
        skioRemoveButtons();
      }, 200);
    });
  }
  if (url.includes("/a/account/subscriptions") || url.includes("/a/account/login")) {
    document.querySelector("#__next").style.paddingTop = "40px";
    skioWaitForElm('#__next .SubscriptionGroup-Active h3').then(() => {
      setTimeout( function() {
        skioRemoveButtons();
      }, 200);
    });
  }
}

function skioRemoveButtons() {
  console.log("skio remove buttons");
  let cards = document.querySelectorAll('#__next .SubscriptionCard');
  cards.forEach((card) => {
    console.log("for each card");
    let foundProduct = false;
    let bodys = card.querySelectorAll('.SubscriptionBody');
    bodys.forEach((body) => {
      console.log("for each body");
      foundProduct = skioElementContainsSubstring(body, variantTitle);
      console.log("found? ", foundProduct, body);
    });
    if (foundProduct) {
      let nextOrderDate = card.querySelector('[aria-label="Set your next order date"]');
      if (nextOrderDate) nextOrderDate.parentNode.remove();
      let get_now = card.querySelector('[aria-label="Order Now"]');
      if (get_now) get_now.parentNode.remove();
      card.classList.add("last-book-in-series");
    }
  });
}

function skioElementContainsSubstring(element, substring) {
  const childElements = element.querySelectorAll("*");
  for (const child of childElements) {
      if (child.textContent.includes(substring)) return true;
  }
  return false;
}

function skioWaitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }
    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}
